import { gql } from 'apollo-angular';

const GET_SYS_SELLER = gql`
  query organization($parentCompanyId: Long!) {
    organization(id: $parentCompanyId, allChildren: true) {
      id
      name
      parent {
        id
        name
      }
      children {
        id
        name
      }
    }
  }
`;

export default GET_SYS_SELLER;
